import { PlusOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Row, Typography, Skeleton } from "antd";
import axios from "axios";
import { BookingSeason } from "containers/Company/EventBooking/interface";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const { Input: SkeletonInput } = Skeleton;

const { Title, Text } = Typography;

function BookingSeasons() {
  const [seasons, setSeasons] = useState<BookingSeason[]>([]);
  const [fetching, setFetching] = useState(true);
  const history = useHistory();

  useEffect(() => {
    axios
      .get<BookingSeason[]>("/booking-seasons/")
      .then(response => {
        const sortedSeasons = response.data.sort((a, b) => {
          if (a.year === b.year) {
            return Number(b.is_fall) - Number(a.is_fall);
          }
          return b.year - a.year;
        });
        setSeasons(sortedSeasons);
      })
      .finally(() => setFetching(false));
  }, []);

  return (
    <Card>
      <Row justify="space-between" align="middle">
        <Title level={2}>Bookingsesonger</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push("/admin/tools/booking-seasons/new/")}
        >
          Opprett bookingsesong
        </Button>
      </Row>
      <Row justify="center" style={{ margin: "16px 0" }}>
        <Alert
          type="error"
          icon={null}
          message="Denne siden brukes til å administrere booking av bedriftspresentasjoner. Det er viktig at denne siden håndteres med stor forsiktighet, da både tekniske feil og feil i datoer kan føre til unødvendige problemer for Bindeleddet og bedriftene. 
          For å sikre at alle aspekter er under kontroll, bør opprettelse av booking-sesonger gjøres i samarbeid mellom Bedriftsleder og en representant fra IT-gruppen."
        />
      </Row>
      {fetching && <SkeletonInput block style={{ height: 100 }} />}
      <Row>
        {seasons.map(season => (
          <Card
            key={season.id}
            style={{ marginBottom: "16px", width: "100%", cursor: "pointer" }}
            onClick={() => history.push(`/admin/tools/booking-seasons/edit/${season.id}/`)}
          >
            <Row justify="space-between">
              <Title level={3}>
                Bedpressesongen {season.is_fall ? "høsten" : "våren"} {season.year}
              </Title>
            </Row>
            <Row>
              <Text>Innsalget åpner: {dayjs(season.booking_open).format("dddd D. MMMM YYYY kl. HH:mm")}</Text>
            </Row>
            <Row>
              <Text>
                Sesongens varighet: {dayjs(season.semester_start).format("D. MMMM")} til{" "}
                {dayjs(season.semester_end).format("D. MMMM")}
              </Text>
            </Row>
          </Card>
        ))}
      </Row>
    </Card>
  );
}

export default BookingSeasons;
